<template>
  <div class="page-width unselectable prodbase" style="margin-top: 75px">
    <div class="half-page">
      <div
        class="flex justify-center flex-wrap gap-2 mb-2"
        style="align-items: flex-start"
      >
        <!--- COPIED --->
        <!--- Kalorienbedarf --->
        <expand-box :barkeeper="barkeeper" :title="title1" :icon="icon1">
          <p>
            Gemäß Deinen Angaben haben wir für Dich einen Kalorienbedarf von
            {{ barkeeper.dailyCalories.toFixed(1) }} berechnet. 
            {{ barkeeper.answers.loseWeight == true ? 'Dieser beinhaltet bereits Deinen Wunsch nach Gewichtsabnahme.' : '' }} 
            Im Zuge der Befragung haben wir Deinen Stoffwechseltyp ermittelt. Mit einer
            Wahrscheinlichkeit von 98,8% bist Du ein
            {{ $t(`type_${barkeeper.type}`) }}.
            <span v-if="barkeeper.type === 'carbohydrate'"
              >Für Dich sind Mahlzeiten optimal, welche reich an Proteinen und
              gesunden Kohlenhydraten sind. Den Anteil von Fetten solltest Du
              reduzieren.</span
            >
            <span v-if="barkeeper.type === 'protein'"
              >Für Dich sind Mahlzeiten optimal, welche reich an Proteinen und
              gesunden pflanzlichen Fetten sind. Den Anteil von Kohlenhydraten
              solltest Du reduzieren.</span
            >
          </p>
          <!---<p v-if="barkeeper.roundPortion === 1000">
                Pro Mahlzeit empfehlen wir aufgrund des hohen Sättigungsgrades
                und der Nährstoffkonzentration nicht mehr als 1.000 Kalorien.
            </p>--->
        </expand-box>
        <!--- Stoffwechseltyp --->

        <!--- Angewohnheiten --->
        <expand-box
          v-if="
            barkeeper.answers.habit.includes('smoking') ||
            barkeeper.answers.habit.includes('alcohol')
          "
          :barkeeper="barkeeper"
          :title="title2"
          :icon="icon2"
        >
          <p>
            Aufgrund Deiner Angaben zum „Rauchen“ bzw. „Alkohol“ empfehle wir
            Dir eine Erhöhung des Vitamin C, Vitamin D und des Vitamin
            B-Komplex-Gehalts. Weiterhin legen wir Dir unser innovatives
            „DNA-Multiprotect“-Paket ans Herz. Ein Verzicht auf diese
            Risikofaktoren ist jedoch anzuraten!
          </p>
        </expand-box>
        <!--- Mangel --->
        <expand-box
          v-if="barkeeper.answers.deficit.length != 0"
          :barkeeper="barkeeper"
          :title="title3"
          :icon="icon3"
        >
          <p>
            Aufgrund Deiner Angaben über einen festgestellten Mangel haben wir
            die Rezeptur für "{{ $t(`${deficits}`) }}" angepasst. Keine Sorge,
            dabei haben wir uns an den Ausarbeitungen des Bundesinstituts für
            Risikobewertung orientiert und gehen bei den Dosierungen keine
            Risiken ein. Konsumiere bitte keine Nahrungsergänzungsmittel an
            Tagen mit Fred
          </p>
        </expand-box>
        <!--- Entgiftung --->
        <expand-box
          v-if="barkeeper.answers.detox1"
          :barkeeper="barkeeper"
          :title="title4"
          :icon="icon4"
        >
          <p>
            Wir empfehlen Dir das nachfolgende Entgiftungspaket, möchten Dir
            aber auch nahelegen Dich mit unseren Ernährungsberatern zu
            besprechen. Nutze dafür einfach das
            <a target="_blank" href="https://dailyfred.de/pages/kontakt"
              >Kontaktformular</a
            >.
          </p>
        </expand-box>
        <!--- Nuss --->
        <expand-box :barkeeper="barkeeper" :title="title5" :icon="icon5">
          <p v-if="!barkeeper.answers.nuts">
            Wir haben den Selengehalt Deines Produkts entsprechend angepasst.
            Damit entsprechen wir neuesten Forschungsergebnissen und ebenfalls
            den Empfehlungen der Deutschen Gesellschaft für Ernährung.
          </p>
          <p v-if="barkeeper.answers.nuts">
            Aufgrund Deiner Angaben zum Verzehr von Paranusskernen haben wir Dir
            Deinen Selengehalt entsprechend reduziert. Damit entsprechen wir
            neuesten Forschungsergebnissen und ebenfalls den Empfehlungen der
            Deutschen Gesellschaft für Ernährung.
          </p>
        </expand-box>
        <!--- Fisch --->
        <expand-box :barkeeper="barkeeper" :title="title6" :icon="icon6">
          <p v-if="!barkeeper.answers.salt">
            Wir haben Deinen Gehalt an Omega-3-Fettsäuren entsprechend
            angepasst. Dabei haben wir darauf geachtet, Dir EPA und DHA in ihrer
            Reinform bereitzustellen und nicht nur die Vorstufe α-Linolensäure.
            Dein Produkt bleibt natürlich trotzdem vegan.
          </p>
          <p v-if="barkeeper.answers.salt">
            Damit beim Thema Jod nichts schief geht, haben wir Deinen Jodgehalt
            entsprechend reduziert. Hinsichtlich Deinem Fischkonsum entsprechen
            Deine Ernährungsgewohnheiten den Empfehlungen der Deutschen
            Gesellschaft für Ernährung.
          </p>
        </expand-box>
        <!--- Vegan/Veggi --->
        <expand-box
          v-if="
            barkeeper.answers.eatHabit === 'vegan' ||
            barkeeper.answers.eatHabit === 'vegetarian'
          "
          :barkeeper="barkeeper"
          :title="title7"
          :icon="icon7"
        >
          <p v-if="barkeeper.answers.eatHabit === 'vegan'">
            Damit Du ein bioverfügbares Vitamin B12 und Eisen erhältst und auch
            bei den anderen kritischen Nährstoffen nichts schief geht, haben wir
            Deinen myFred an die Herausforderungen Deiner veganen Ernährung
            angepasst.
          </p>
          <p v-if="barkeeper.answers.eatHabit === 'vegetarian'">
            Damit Du ein bioverfügbares Vitamin B12 erhältst und auch bei den
            anderen kritischen Nährstoffen nichts schief geht, haben wir Deinen
            myFred an die Herausforderungen einer vegetarischen Ernährung
            angepasst.
          </p>
        </expand-box>
        <!--- Milk --->
        <expand-box :barkeeper="barkeeper" :title="title8" :icon="icon8">
          <p v-if="barkeeper.answers.milk">
            Für eine optimale Versorgung mit Calcium haben wir Deinen
            Calciumgehalt entsprechend Deinen Angaben reduziert, damit Du
            insgesamt pro Tag optimal versorgt bist.
          </p>
          <p v-if="!barkeeper.answers.milk">
            Für eine optimale Versorgung mit Calcium haben wir Deinen
            Calciumgehalt entsprechend Deinen Angaben angepasst.
            Selbstverständlich sind dabei alle Nährstoffe hinsichtlich ihrer
            Bioverfügbarkeit optimiert.
          </p>
        </expand-box>
      </div>

      <div class="grid__item custom-width--descr">
        <div class="product-single__meta">
          <div class="product-single--box minwidth">
            <div class="product-single--top mod-flex product-single__title">
              <h1 class="h2 product-single--top-ttl">MyFred</h1>
              <div class="product-single--top-imgtags">
                <span class="prod-imgtag">
                  <img
                    src="//cdn.shopify.com/s/files/1/0570/9758/4849/t/39/assets/tag-image-nutriscore-a.png?v=7934208609517413242"
                    alt="nutrition score A"
                  /> </span
                ><span class="prod-imgtag">
                  <img
                    src="//cdn.shopify.com/s/files/1/0570/9758/4849/t/39/assets/tag-image-vegan.png?v=2345678599999970143"
                    alt="Vegan"
                  />
                </span>
              </div>
            </div>

            <span class="prod-tagline"
              >Dein gesunder Alleskönner, als leckerer Snack oder als
              vollwertige Mahlzeit.</span
            >
            <div class="product-rev-prc">
              <div class="product-rev-prc--left">
                <span id="PriceA11y-6819538534609" class="visually-hidden"
                  >Normaler Preis</span
                ><span id="ProductPrice-6819538534609" class="product__price">
                  {{
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(shake.price / 100)
                  }} </span
                ><small class="taxes-incl" style="color: #a7a7a7"
                  >inkl. MwSt.
                </small>
              </div>

              <div class="product-rev-prc--right">
                <div
                  style="display: none"
                  class="
                    jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link
                    jdgm--done-setup
                  "
                  data-id="6819538534609"
                  data-template="manual-installation"
                  data-auto-install="false"
                >
                  <div
                    style="display: none"
                    class="jdgm-prev-badge"
                    data-average-rating="0.00"
                    data-number-of-reviews="0"
                    data-number-of-questions="0"
                  >
                    <span
                      class="jdgm-prev-badge__stars"
                      data-score="0.00"
                      tabindex="0"
                      aria-label="0.00 stars"
                      role="button"
                    >
                      <span class="jdgm-star jdgm--off"></span
                      ><span class="jdgm-star jdgm--off"></span
                      ><span class="jdgm-star jdgm--off"></span
                      ><span class="jdgm-star jdgm--off"></span
                      ><span class="jdgm-star jdgm--off"></span>
                    </span>
                    <span class="jdgm-prev-badge__text">Keine Bewertungen</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="
                product__unit-price
                product__unit-price--spacing
                product__unit-price-wrapper--6819538534609
                hide
              "
            >
              <span class="product__unit-price--6819538534609"></span>/<span
                class="product__unit-base--6819538534609"
              ></span>
            </div>

            <small class="Versandhinweis">
              <ul
                style="
                  margin-left: 0px;
                  margin-top: 15px;
                  list-style-position: inside;
                "
              >
                <li>{{ versandhinweis }}</li>
                <li><b>Mindestbestellmenge</b> 20 Stück</li>
              </ul>
            </small>
            <div class="product-single--policies product__policies rte"></div>

            <table class="mx-auto divide-y divide-gray-200 rounded tablelayout">
              <tr>
                <td
                  class="
                    py-2
                    whitespace-nowrap
                    text-base
                    font-semibold
                    text-gray-500
                  "
                >
                  Basis
                </td>
                <td
                  class="
                    py-2
                    whitespace-nowrap
                    text-base
                    font-semibold
                    text-gray-500
                  "
                >
                  {{
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(shake.basePrice / 100)
                  }}
                </td>
                <td></td>
              </tr>
              <tr
                v-for="addon in shake.addons.filter((a) => a.price != 0)"
                :key="addon.title"
              >
                <td
                  class="
                    py-2
                    whitespace-nowrap
                    text-base
                    font-semibold
                    text-gray-500
                  "
                >
                  {{ $t(`${addon.title}`) }}
                </td>
                <td
                  class="
                    py-2F
                    whitespace-nowrap
                    text-base
                    font-semibold
                    text-gray-500
                  "
                >
                  {{
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(addon.price / 100)
                  }}
                </td>
                <td
                  class="
                    py-2
                    whitespace-nowrap
                    text-base
                    font-semibold
                    text-gray-500
                    cursor-pointer
                  "
                  @click="removeAddon(addon)"
                >
                  <img
                    :src="'https://your-fred.web.app/icons/icons8-löschen-50.png'"
                    style="width: 25px; height: 25px; max-width: 25px; transform: scale(0.65); float: right;"
                  />
                </td>
              </tr>
            </table>
            <div
              id="AddToCartForm-6819538534609"
              accept-charset="UTF-8"
              class="product-single__form"
              enctype="multipart/form-data"
            >
              <!-- Seal Subscriptions auto 
--->
              <!---
  <select name="id" data-productid="6819538534609" id="ProductSelect-6819538534609" class="product-single__variants no-js"><option selected="selected" value="40391470907601">
          Schoko Frucht - €14,90 EUR
        </option><option value="40391470940369">
          Erdbeere Schoko - €14,90 EUR
        </option><option value="40391470973137">
          Erdbeere Kokos - €14,90 EUR
        </option><option value="40391471005905">
          Erdbeere Himbeere - €14,90 EUR
        </option><option value="40391471038673">
          Erdbeere Mango Zitrone - €14,90 EUR
        </option><option value="40391471071441">
          Kokos Ananas - €14,90 EUR
        </option><option value="40391471104209">
          Classic Detox - €14,90 EUR
        </option></select> --->
              <div class="product__quantity product__quantity--dropdown">
                <div class="js-qty__wrapper">
                  <input
                    type="text"
                    id="Quantity-6819538534609"
                    class="js-qty__num"
                    v-model="quantity"
                    min="20"
                    aria-label="quantity"
                    pattern="[0-9]*"
                    name="quantity"
                  />
                  <button
                    @click="removequantity()"
                    type="button"
                    class="js-qty__adjust js-qty__adjust--minus"
                    aria-label="Artikelmenge um eins reduzieren"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-minus"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#444"
                        d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"
                      ></path>
                    </svg>
                    <span class="icon__fallback-text" aria-hidden="true"
                      >−</span
                    >
                  </button>
                  <button
                    @click="quantity++"
                    type="button"
                    class="js-qty__adjust js-qty__adjust--plus"
                    aria-label="Artikelmenge um eins erhöhen"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-plus"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#444"
                        d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"
                      ></path>
                    </svg>
                    <span class="icon__fallback-text" aria-hidden="true"
                      >+</span
                    >
                  </button>
                </div>
              </div>
              <button
                @click="buyProduct"
                class="btn btn--full add-to-cart"
                :class="{ 'btn--loading': checkoutLoading }"
              >
                <span
                  >Jetzt kaufen</span
                >
              </button>

              <!-- <div class="custom">
    <span>Kostenloser Versand ab 69€</span>
  </div> -->

              <textarea
                id="VariantsJson-6819538534609"
                class="hide"
                aria-hidden="true"
              >
    [{"id":40391470907601,"title":"Schoko Frucht","option1":"Schoko Frucht","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175659888849,"product_id":6819538534609,"position":1,"created_at":"2021-10-13T10:21:03+02:00","updated_at":"2021-10-13T10:21:03+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1620_a_Q_Shop_Schoko-Frucht_2977ce27-84c2-43fa-9502-26ecc58be09e.jpg?v=1634113263","variant_ids":[40391470907601]},"available":true,"name":"AlFred Pure Nature - Schoko Frucht","public_title":"Schoko Frucht","options":["Schoko Frucht"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":"shopify","barcode":null,"featured_media":{"alt":null,"id":21448855388369,"position":1,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1620_a_Q_Shop_Schoko-Frucht_2977ce27-84c2-43fa-9502-26ecc58be09e.jpg?v=1634113263"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391470940369,"title":"Erdbeere Schoko","option1":"Erdbeere Schoko","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175659987153,"product_id":6819538534609,"position":4,"created_at":"2021-10-13T10:21:04+02:00","updated_at":"2021-10-13T10:21:04+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1674_a_Q_Shop_Erdbeer-Schoko_4d854cd4-f615-4fa7-9945-00527fb124d0.jpg?v=1634113264","variant_ids":[40391470940369]},"available":true,"name":"AlFred Pure Nature - Erdbeere Schoko","public_title":"Erdbeere Schoko","options":["Erdbeere Schoko"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448855519441,"position":4,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1674_a_Q_Shop_Erdbeer-Schoko_4d854cd4-f615-4fa7-9945-00527fb124d0.jpg?v=1634113264"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391470973137,"title":"Erdbeere Kokos","option1":"Erdbeere Kokos","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175660150993,"product_id":6819538534609,"position":7,"created_at":"2021-10-13T10:21:04+02:00","updated_at":"2021-10-13T10:21:04+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1664_a_Q_Shop_Erdbeer-Kokos_40cd55e8-258d-491d-9584-11de4a4cb5fb.jpg?v=1634113264","variant_ids":[40391470973137]},"available":true,"name":"AlFred Pure Nature - Erdbeere Kokos","public_title":"Erdbeere Kokos","options":["Erdbeere Kokos"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448855650513,"position":7,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1664_a_Q_Shop_Erdbeer-Kokos_40cd55e8-258d-491d-9584-11de4a4cb5fb.jpg?v=1634113264"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391471005905,"title":"Erdbeere Himbeere","option1":"Erdbeere Himbeere","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175660249297,"product_id":6819538534609,"position":10,"created_at":"2021-10-13T10:21:04+02:00","updated_at":"2021-10-13T10:21:04+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1688_a_Q_Shop_Erdbeer-Himbeer_e930274c-147c-470b-8f8b-ac2db03acf12.jpg?v=1634113264","variant_ids":[40391471005905]},"available":true,"name":"AlFred Pure Nature - Erdbeere Himbeere","public_title":"Erdbeere Himbeere","options":["Erdbeere Himbeere"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448855781585,"position":10,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1688_a_Q_Shop_Erdbeer-Himbeer_e930274c-147c-470b-8f8b-ac2db03acf12.jpg?v=1634113264"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391471038673,"title":"Erdbeere Mango Zitrone","option1":"Erdbeere Mango Zitrone","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175660347601,"product_id":6819538534609,"position":13,"created_at":"2021-10-13T10:21:05+02:00","updated_at":"2021-10-13T10:21:05+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1694_a_Q_Shop_Erdbeer-Mango-Zitro_fa51130a-d771-47b8-8ba5-18de94bdd1e1.jpg?v=1634113265","variant_ids":[40391471038673]},"available":true,"name":"AlFred Pure Nature - Erdbeere Mango Zitrone","public_title":"Erdbeere Mango Zitrone","options":["Erdbeere Mango Zitrone"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448855879889,"position":13,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1694_a_Q_Shop_Erdbeer-Mango-Zitro_fa51130a-d771-47b8-8ba5-18de94bdd1e1.jpg?v=1634113265"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391471071441,"title":"Kokos Ananas","option1":"Kokos Ananas","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175660544209,"product_id":6819538534609,"position":18,"created_at":"2021-10-13T10:21:05+02:00","updated_at":"2021-10-13T10:21:05+02:00","alt":null,"width":1600,"height":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1711_a_Q_Shop_Kokos-Ananas_5c168956-49a9-40d4-99cf-53cea744747b.jpg?v=1634113265","variant_ids":[40391471071441]},"available":true,"name":"AlFred Pure Nature - Kokos Ananas","public_title":"Kokos Ananas","options":["Kokos Ananas"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448856076497,"position":18,"preview_image":{"aspect_ratio":1.0,"height":1600,"width":1600,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DailyFred_Optifood_Daily_Fred__1711_a_Q_Shop_Kokos-Ananas_5c168956-49a9-40d4-99cf-53cea744747b.jpg?v=1634113265"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]},{"id":40391471104209,"title":"Classic Detox","option1":"Classic Detox","option2":null,"option3":null,"sku":"","requires_shipping":true,"taxable":true,"featured_image":{"id":29175660576977,"product_id":6819538534609,"position":19,"created_at":"2021-10-13T10:21:05+02:00","updated_at":"2021-10-13T10:21:05+02:00","alt":null,"width":3000,"height":3000,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DSC_1721_a_Q_Shop_Basic_4ce666f8-1df3-42a6-a736-a9d6f4f5f871.jpg?v=1634113265","variant_ids":[40391471104209]},"available":true,"name":"AlFred Pure Nature - Classic Detox","public_title":"Classic Detox","options":["Classic Detox"],"price":1490,"weight":500,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":21448856109265,"position":19,"preview_image":{"aspect_ratio":1.0,"height":3000,"width":3000,"src":"https:\/\/cdn.shopify.com\/s\/files\/1\/0570\/9758\/4849\/products\/DSC_1721_a_Q_Shop_Basic_4ce666f8-1df3-42a6-a736-a9d6f4f5f871.jpg?v=1634113265"}},"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":1290}],"price":1290,"compare_at_price":1490,"per_delivery_price":1290,"selling_plan_id":530120913,"selling_plan_group_id":"ee9a5eb6fa501e85bd018f9163d3b7e1ee32d0bc"}]}]
  </textarea
              >
            </div>
            <div class="aos-animate trust-image" style="max-width: 1024px">
              <div
                class="image-wrap2"
                style="height: 0; padding-bottom: 8.10546875%"
              >
                <img
                  class="lazyautosizes lazyloaded"
                  data-widths="[360, 540, 700, 1024]"
                  data-aspectratio="12.337349397590362"
                  data-sizes="auto"
                  alt=""
                  data-srcset="//cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_360x.png?v=1623416695 360w, //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_540x.png?v=1623416695 540w, //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_700x.png?v=1623416695 700w, //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_1024x.png?v=1623416695 1024w"
                  sizes="381px"
                  srcset="
                    //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_360x.png?v=1623416695   360w,
                    //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_540x.png?v=1623416695   540w,
                    //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_700x.png?v=1623416695   700w,
                    //cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_1024x.png?v=1623416695 1024w
                  "
                />
                <noscript>
                  <img
                    class="lazyloaded"
                    src="//cdn.shopify.com/s/files/1/0570/9758/4849/files/payment-anbieter-bergmensch33_1024x_eb18a0a7-59f8-493a-aff7-366586c75238_540x.png?v=1623416695"
                    alt=""
                  />
                </noscript>
              </div>
            </div>
            <div class="collection-banner--row collBanners">
              <div class="collection-banner--col collBanner">
                <div class="collection-banner--item collBannerClick">
                  <span class="collection-banner--item-close collBannerClose">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M0 0h24v24H0V0z" fill="none"></path>
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                      ></path>
                    </svg>
                  </span>
                  <div class="collection-banner--item-inner w-100">
                    <div class="collection-banner--item-top">
                      <div class="collection-banner--item-top-img">
                        <img
                          src="//cdn.shopify.com/s/files/1/0570/9758/4849/files/icons8-shipped_5ab517cc-a27a-4a6c-9cfc-d88c8ef07d68_30x.png?v=1627914478"
                          alt="Versand gratis ab 100€"
                        />
                      </div>
                      <div class="collection-banner--item-top-title">
                        Versand gratis ab 100€
                      </div>
                    </div>
                    <div class="collection-banner--item-top-text">
                      Lorem ipsum
                    </div>
                  </div>
                </div>
              </div>

              <div class="collection-banner--col collBanner">
                <div class="collection-banner--item collBannerClick">
                  <span class="collection-banner--item-close collBannerClose">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M0 0h24v24H0V0z" fill="none"></path>
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                      ></path>
                    </svg>
                  </span>
                  <div class="collection-banner--item-inner w-100">
                    <div class="collection-banner--item-top">
                      <div class="collection-banner--item-top-img">
                        <img
                          src="//cdn.shopify.com/s/files/1/0570/9758/4849/files/icons8-consumable_30x.png?v=1621000582"
                          alt="30 Tage Rückgaberecht"
                        />
                      </div>
                      <div class="collection-banner--item-top-title">
                        30 Tage Rückgaberecht
                      </div>
                    </div>
                    <div class="collection-banner--item-top-text">
                      Lorem ipsum
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-single__description">
              <div class="product-accordions">
                <button
                  @click="showinfo"
                  type="button"
                  :class="{ 'is-open': show }"
                  class="collapsible-trigger collapsible-trigger-btn text-left"
                  aria-controls="product-accordion-01"
                  aria-expanded="false"
                >
                  ZUTATENLISTE
                  <span class="collapsible-trigger--icn"></span>
                </button>

                <div
                  id="product-acc"
                  :class="{ 'is-open': show, heightset: show }"
                  class="
                    collapsible-content
                    collapsible-content--all
                    collapsible-content--alt
                  "
                >
                  <div class="collapsible-content__inner rte" style="margin-bottom: 10px;">
                    <span
                      v-for="(ingredient, index) in barkeeper.ingredients"
                      :key="ingredient"
                    >
                      {{ ingredient
                      }}<span v-if="index != barkeeper.ingredients.length - 1"
                        >,
                      </span>
                    </span>
                    <br>
                  </div>
                </div>
                <p class="prod-tagline" style="
                    margin-top: 4 px;
                    line-height: 1.1;
                    font-size: 11px;
                    font-weight: 400;
                    letter-spacing: normal;
                    color: #a2a2a2;
                  ">
                  Wir können durch unsere Produkte keine Wunder vollbringen,
                  sondern angepasst an Deine persönlichen Rahmenbedingungen ein
                  Produkt konfigurieren, dass gemäß der Health Claims-Verordnung
                  einen signifikanten Beitrag zum Erhalt Deiner Gesundheit
                  leisten kann!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product-single--box" style="margin-top: 2rem">
      <div class="product-single--top mod-flex product-single__title">
        <h1 class="h2 product-single--top-ttl" style="margin-bottom: 1rem">
          Nährstoffe
        </h1>
      </div>
      <div class="inline-grid fooddetail" style="width: 100%; table-layout: fixed;">
        <table
          v-if="barkeeper.answers['jobhours'] != ''"
          id="ing_table"
          class="mx-auto divide-y divide-gray-200 rounded"
          style="width: 100%; table-layout: fixed;"
        >
          <thead class="">
            <tr>
              <th
                scope="col"
                class="
                  px-6
                  py-3
                  text-lg
                  font-semibold
                  text-gray-900
                  uppercase
                  tracking-wider
                  thead
                "
                style="background-color: white"
              >
                Nährstoff
              </th>
              <th
                scope="col"
                class="
                  px-6
                  py-3
                  text-lg
                  font-semibold
                  text-gray-900
                  uppercase
                  tracking-wider
                  thead
                "
                style="background-color: white"
              >
                Tagesbedarf *
              </th>
              <th
                scope="col"
                class="
                  px-6
                  py-3
                  text-lg
                  font-semibold
                  text-gray-900
                  uppercase
                  tracking-wider
                  thead
                "
                style="background-color: white"
              >
                Inhalt pro Einheit
              </th>
              <th
                scope="col"
                class="
                  px-6
                  py-3
                  text-lg
                  font-semibold
                  text-gray-900
                  uppercase
                  tracking-wider
                  thead
                "
                style="background-color: white"
              >
                Tagesbedarf in %
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("calories") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ (barkeeper.dailyCalories).toFixed(2) }} {{ units["calories"] }}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.calories }} {{ units["calories"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((shake.calories / barkeeper.dailyCalories) * 100).toFixed(2) }} %
              </td>
            </tr>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("carbohydrate") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((barkeeper.dailyCalories*0.5)/4.1).toFixed(2) }} {{ units["carbohydrate"]}}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.carbohydrate }} {{ units["carbohydrate"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((shake.carbohydrate / ((barkeeper.dailyCalories*0.5)/4.1)) * 100).toFixed(2) }} %
              </td>
            </tr>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("sugar") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((barkeeper.dailyCalories*0.1)/4.1).toFixed(2) }} {{ units["sugar"]}}
              </td> 
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.sugar }} {{ units["sugar"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ (( shake.sugar / ((barkeeper.dailyCalories*0.1)/4.1)) * 100).toFixed(2) }} %
              </td> 
            </tr>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("fiber") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ daily[barkeeper.person.gender]["fiber"] }} {{ units["fiber"] }}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.fiber }} {{ units["fiber"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((shake.fiber / daily[barkeeper.person.gender]["fiber"]) * 100).toFixed(2) }} %
              </td>
            </tr>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("fat") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((barkeeper.dailyCalories*0.3)/9.3).toFixed(2) }} {{ units["fat"]}}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.fat }} {{ units["fat"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((shake.fat / ((barkeeper.dailyCalories*0.3)/9.3)) * 100).toFixed(2) }} %
              </td>
            </tr>
            <tr @click="showMore('fattyAcids')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("fattyAcids") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{ 'rotate-180': arrayAll.includes('fattyAcids') }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.fattyAcids"
              :key="index"
              :index="index"
              :value="value"
              :name="'fattyAcids'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
            />
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("salt") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ daily[barkeeper.person.gender]["salt"] }} {{ units["salt"] }}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.salt }} {{ units["salt"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              </td>
            </tr>
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("protein") }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((barkeeper.dailyCalories*0.2)/4.1).toFixed(2) }} {{ units["protein"] }}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.protein }} {{ units["protein"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ ((shake.protein / ((barkeeper.dailyCalories*0.2)/4.1)) * 100).toFixed(2) }} %
              </td>
            </tr>
            <tr @click="showMore('essentialAminoAcids')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("essentialAminoAcids") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{
                    'rotate-180': arrayAll.includes('essentialAminoAcids'),
                  }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.essentialAminoAcids"
              :key="index"
              :index="index"
              :value="value"
              :name="'essentialAminoAcids'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
              :weight="barkeeper.person.weight"
            />
            <tr @click="showMore('noEssentialAminoAcids')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("noEssentialAminoAcids") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{
                    'rotate-180': arrayAll.includes('noEssentialAminoAcids'),
                  }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.noEssentialAminoAcids"
              :key="index"
              :index="index"
              :value="value"
              :name="'noEssentialAminoAcids'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
            />
            <tr @click="showMore('vitamins')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("vitamins") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{ 'rotate-180': arrayAll.includes('vitamins') }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.vitamins"
              :key="index"
              :index="index"
              :value="value"
              :name="'vitamins'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
            />
            <tr @click="showMore('minerals')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("minerals") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{ 'rotate-180': arrayAll.includes('minerals') }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.minerals"
              :key="index"
              :index="index"
              :value="value"
              :name="'minerals'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
            />
            <tr @click="showMore('traceElements')" class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("traceElements") }}
              </td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
              ></td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div
                  class="
                    cursor-pointer
                    z-10
                    transform
                    transition-transform
                    inline-block
                    float-right
                  "
                  :class="{ 'rotate-180': arrayAll.includes('traceElements') }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="display: unset"
                    class="h-8 w-15"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <sub-table
              v-for="(value, index) in shake.traceElements"
              :key="index"
              :index="index"
              :value="value"
              :name="'traceElements'"
              :gender="barkeeper.person.gender"
              :arrayAll="arrayAll"
            />
            <tr class="">
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ $t("chlorophyll") }} **
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ daily[barkeeper.person.gender]["chlorophyll"] }}
              </td>
              <td
                class="
                  px-6
                  py-4
                  whitespace-nowrap
                  text-sm
                  font-semibold
                  text-gray-500
                "
              >
                {{ shake.chlorophyll }} {{ units["chlorophyll"] }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              </td>
              <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ units["chlorophyll"] }}
              </td>-->
            </tr>
          </tbody>
        </table>
        <div style="margin-top: 12px">
        <p>* empfohlene Tagesdosis augrund Deiner Angaben</p>
        <p>** (noch) keine Nährstoffreferenzwerte</p>
        <p>*** hauseigene Empfehlung aufgrund Deiner Gewohnheiten</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SubTable from "@/components/SubTable.vue";
import ExpandBox from "@/components/ExpandBox";
import { Barkeeper } from "../util/shake/Barkeeper";
import dailyValues from "@/calorie-table/dailyValues.json";
import units from "@/calorie-table/units.json";
import { db } from "@/firebase";
import Client from 'shopify-buy';
import axios from 'axios'

const MYFRED_VARIANT_ID = "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zOTc5OTkyNDg4MzY2NQ=="
const MYFRED_EXTENSION_VARIANT_ID = "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDQ3NTI1NjA2MjE2MQ=="

const client = Client.buildClient({
  domain: 'getyourfred.myshopify.com',
  storefrontAccessToken: '4e23884658a9630db7565a6e4adb33e0'
});
global.client = client


export default {
  components: {
    ExpandBox,
    SubTable,
  },
  data() {
    return {
      removedAddons: [],
      versandhinweis: window.versandhinweis || '2-3 Tage',
      quantity: 20,
      rotate: true,
      ingreds: "",
      subTable: false,
      arrayAll: [],
      barkeeper: {},
      shake: {},
      daily: dailyValues,
      units: units,
      toggle1: false,
      toggle2: false,
      toggle3: false,
      toggle4: false,
      show: false,
      icon1: "https://your-fred.web.app/icons/calories.png",
      icon2: "https://your-fred.web.app/icons/herz.png",
      icon3: "https://your-fred.web.app/icons/deficit.png",
      icon4: "https://your-fred.web.app/icons/detox.png",
      icon5: "https://your-fred.web.app/icons/nuts.png",
      icon6: "https://your-fred.web.app/icons/fish.png",
      icon7: "https://your-fred.web.app/icons/vegetarian.png",
      icon8: "https://your-fred.web.app/icons/milk.png",
      title1: "Kalorienbedarf",
      title2: "Angewohnheiten",
      title3: "Nachgewiesene Mängel",
      title4: "Entgiftungspaket",
      title5: "Paranusskerne",
      title6: "Fisch",
      title7: "Besondere Ernährungsangewohnheiten",
      title8: "Milchprodukte",
      checkoutLoading: false
    };
  },
  computed: {
    addons() {
      return this.shake.addons;
    },
    deficits() {
      let deficitString = "";
      for (let a of this.barkeeper.answers.deficit) {
        deficitString += this.$t(`${a}`);
        if (
          this.barkeeper.answers.deficit.length >
          this.barkeeper.answers.deficit.indexOf(a) + 1
        ) {
          deficitString += ", ";
        }
      }
      return deficitString;
    },
    consumptions() {
      let consumptionString = "";
      for (let a of this.barkeeper.answers.consumption) {
        consumptionString += this.$t(`${a}`);
        if (
          this.barkeeper.answers.consumption.length >
          this.barkeeper.answers.consumption.indexOf(a) + 1
        ) {
          consumptionString += ", ";
        }
      }
      return consumptionString;
    },
  },
  props: {
    answers: {
      Type: Object,
    },
  },
  methods: {
    removequantity() {
        if (this.quantity >20) {
          this.quantity--
        }
    },
    async buyProduct() {
        this.checkoutLoading = true
        const checkout = await client.checkout.create()
        console.log(checkout)
        const search = new URLSearchParams(window.location.search)

        console.log(`https://dailyfred.de/products/myfred?shake=${search.get('shake')}&remadd=${encodeURIComponent(this.removedAddons.join(','))}`)
        console.log(this.removedAddons)
        console.log(this.removedAddons.join(','))

        const lineItemsToAdd = [
            {
                variantId: MYFRED_VARIANT_ID,
                quantity: this.quantity,
                customAttributes: [{key: "_shakeID", value: `https://dailyfred.de/products/myfred?shake=${search.get('shake')}&remadd=${encodeURIComponent(this.removedAddons.join(','))}`}]
            },
            {
                variantId: MYFRED_EXTENSION_VARIANT_ID,
                quantity: (this.shake.price - this.shake.pureBasePrice) * this.quantity,
                customAttributes: [{key: "_shakeID", value: `https://dailyfred.de/products/myfred?shake=${search.get('shake')}&remadd=${encodeURIComponent(this.removedAddons.join(','))}`}]
            }
        ].filter(item => item.quantity > 0)
        console.log(await client.checkout.addLineItems(checkout.id, lineItemsToAdd))
        console.log(JSON.stringify(checkout))

        window.location.href = checkout.webUrl
        
    },
    showinfo() {
      this.show = !this.show;
    },
    showMore(val) {
      if (this.arrayAll.includes(val)) {
        this.arrayAll.splice(this.arrayAll.indexOf(val), 1);
      } else {
        this.arrayAll.push(val);
      }
    },
    removeAddon(addon) {
      console.log({ addon })
      console.log({ shake: this.shake })
      this.removedAddons.push(addon.title);
      this.shake.removeAddon(addon);
    }
  },
  async mounted() {
    global.__product = this
    const search = new URLSearchParams(window.location.search);
    if (!search.get("shake")) {
      let ans = {
        answers: {
          ...this.answers,
        },
      };
      this.barkeeper = new Barkeeper(this.answers);
      this.shake = this.barkeeper.mixShake;
      const document = db.collection("shakes").doc();
      await document.set({ createdAt: new Date(), ...ans }, { merge: true });
      axios.post('https://us-central1-your-fred.cloudfunctions.net/createProduct', {
        name: this.answers.name,
        url: window.location.origin +
            window.location.pathname +
            "?" +
            `shake=${document.id}`,
        email: this.answers.email
      })
      if (document.id) {
        history.pushState(
          {},
          null,
          window.location.origin +
            window.location.pathname +
            "?" +
            `shake=${document.id}`
        );
      }
      console.log(
        window.location.origin +
          window.location.pathname +
          "?" +
          `shake=${document.id}`
      );
      console.log(this.shake);
    }
    if (search.get("shake")) {
      const shake = await db
        .collection("shakes")
        .doc(search.get("shake"))
        .get();
      this.barkeeper = new Barkeeper(shake.data().answers);
      this.shake = this.barkeeper.mixShake;
      if(search.get("remadd")){
        const remadd = search.get("remadd").split(',')
        remadd.forEach(addon => this.removeAddon(
          {
            title: addon
          }
        ))
      }
      console.log(this.shake);
    }
  },
};
</script>
<style>
@media screen and (max-width: 480px) {
  #ing_table .text-sm, #ing_table .text-sm > div, #ing_table th.text-lg {
    font-size: 0.55rem!important;
    hyphens: auto;
  }
}
</style>
<style scoped>
.js-qty__wrapper [type=text] {
    border-color: transparent;
    background: #f8f8f8;
}


.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
     Introduced in IE 10.
     See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
   */
  -ms-user-select: none;
  user-select: none;
}

.ingrid h3 {
  font-size: 2rem !important;
  letter-spacing: 5px;
  font-weight: bolder;
}

.borderbox {
  background-color: #f2f2f2;
  border-radius: 30px;
  padding: 15px;
  width: fit-content;
  max-width: 500px;
  margin: auto;
  margin-bottom: 40px;
}
.badge1 {
  background-color: #e7a5a3;
  color: white;
  border-radius: 30px;
  width: fit-content;
  padding: 0px 30px;
  margin: auto;
  margin-bottom: 10px;
}
.badge2 {
  background-color: #8a8ad5;
  color: white;
  border-radius: 30px;
  width: fit-content;
  padding: 0px 30px;
  margin: auto;
  margin-bottom: 10px;
}
.badge3 {
  background-color: #85c7a8;
  color: white;
  border-radius: 30px;
  width: fit-content;
  padding: 0px 30px;
  margin: auto;
  margin-bottom: 10px;
}
.badge4 {
  background-color: #000000;
  color: white;
  border-radius: 30px;
  width: fit-content;
  padding: 0px 30px;
  margin: auto;
  margin-bottom: 10px;
  font-size: 2rem !important;
  letter-spacing: 5px;
}
.box1 {
  background-color: rgba(231, 165, 163, 0.2);
}
.box2 {
  background-color: rgba(138, 138, 213, 0.2);
}
.box3 {
  background-color: rgba(133, 199, 168, 0.2);
  text-align: center;
}

.tablee {
  background-color: #e7a5a3;
}
.heightset {
  height: -webkit-fill-available !important;
  height: fit-content!important;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}

table {
  border-radius: 5px !important;
  -moz-border-radius: 5px !important;
  border-collapse: collapse !important;
  border: none !important;
}
.ingrid {
  display: inline-grid;
}
#ing_table th,
td {
  background: inherit;
}
.fooddetail table {
  background: none !important;
}
.coolbubble {
  flex-basis: calc(20% - 8px);
  height: 280px;
  margin-bottom: 8px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}
.expand {
  height: auto !important;
  overflow: visible !important;
}
.whiteplusfull {
  top: 94% !important;
}
.whiteplusfull2 {
  top: 92% !important;
}
.whiteplus {
  position: absolute;
  left: calc(50% - 25px);
  top: 80%;
  height: 50px;
  width: 50px;
  background-color: white;
  border-radius: 50%;
}
.tablelayout {
  margin-bottom: 28px;
}
.tablelayout tr {
  background-color: white;
}
.half-page {
  display: flex;
}
.grid__item {
  display: flex;
}
.is-open {
  overflow: visible;
}
#ing_table tr {
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}
.acc-item-tile{
    background-color: white;
}
.thead{
    border-bottom: 2px solid #ddd;
    border-top: none;
}
.minwidth{
    min-width: 400px;
}
.tablelayout td{
    padding: 0px 0px
}
@media screen and (max-width: 500px) {
    .minwidth {
        min-width: unset;
    }
}


    
@media screen and (max-width: 680px) {
    .th-resp{
        font-size: 13px
    }
    .half-page{
        flex-wrap: wrap-reverse
    }
    .grid__item {
        margin-left: 0px;
        padding-left: 0px;
        width: 100%;
        margin-bottom: 1rem
    }
    td {
        padding-right: 0!important;
        padding-left: 0!important;
    }

    td:not(:first-child) {
        text-align: right!important;
    }

    th {
        padding: 2px 0!important;
        line-height: 1.2em!important;
        font-size: 12px!important;
    }

    th:not(:first-child) {
        text-align: right;
    }
}


</style>